import styled from "styled-components";

export const StyledContainerAuthSign = styled.div<{ bg_color: string }>`
    padding: 25px;
    background-color: ${(p) => p.theme.colors.card};

    position: relative;
    top: -85px;
    border-radius: 8px;
    text-align: center;
    /* box-shadow: 0px 4px 10px 1px #e7e2e2; */
    .allow-dropdown.intl-tel-input {
        width: 100% !important;
        background-color: #f7f7f8;
    }
    .intl-tel-input.allow-dropdown input[type="text"],
    .intl-tel-input.allow-dropdown input[type="tel"] {
        height: 48px !important;
        outline: none;
        border: none;
        background-color: #f7f7f8;
        width: 100% !important;
        font-size: 16px;
        color: inherit;
        box-shadow: none !important;
        font-weight: 500;
    }
    .title_auth {
        font-style: normal;
        line-height: 1.25em;
        color: #000000;
        margin-bottom: 4px;
        margin-top: 12px;
    }
    .choose_auth {
        line-height: 21px;
        color: #919191 !important;
        margin-bottom: 30px;
    }
    .site-form-item-icon {
        font-size: 20px;
    }
    .forgot {
        font-size: 15px;
        line-height: 21px;
        font-weight: 500;
        color: #646464;
        text-align: start;
        margin-top: 16px;
        span {
            color: ${(p) => p.bg_color};
            cursor: pointer;
        }
    }
    .remember {
        text-align: start;
        font-weight: 500;
        font-size: 15px;
        line-height: 21px;
        margin-top: 8px;
        color: #646464;
    }
`;

export const StyledContainerAuthSignUp = styled.div<{ bg_color: string }>`
    padding: 25px;
    background-color: ${(p) => p.theme.colors.card};
    position: relative;
    top: -80px;
    border-radius: 12px;
    text-align: center;
    /* box-shadow: 0px 4px 10px 1px #e7e2e2; */
    .login-skeleton {
        .ant-skeleton {
            .ant-skeleton-content {
                .ant-skeleton-title {
                    margin:0 auto;
                    height: 10px;
                    border-radius: 16px;
                    margin-bottom: 15px;
                }
                .ant-skeleton-paragraph {
                    li {
                        margin:0 auto;
                        width:100%!important;
                        border-radius: 16px;
                        height: 60px;
                        margin-bottom: 15px;
                    }
                }
            }
        }
    }
    .allow-dropdown.intl-tel-input {
        width: 100% !important;
        background-color: inherit;
    }
    .intl-tel-input.allow-dropdown input[type="text"],
    .intl-tel-input.allow-dropdown input[type="tel"] {
        height: 48px !important;
        outline: none;
        border: none;
        background-color: inherit;
        width: 100% !important;
        font-size: 16px;
        color: ${(p) => p.theme.colors.color};
        box-shadow: none !important;
        font-weight: 500;
    }
    .title_auth {
        font-style: normal;
        line-height: 1.25em;
        color: ${(p) => p.theme.colors.color};
        margin-bottom: 4px;
        margin-top: 12px;
        .ant-skeleton {
            .ant-skeleton-paragraph {
                margin-bottom: 8px;
                li {
                    margin: 0 auto;
                    height: 10px;
                    border-radius: 16px;
                }
            }
        }
    }
    .choose_auth {
        line-height: 21px;
        color: #676767;
        margin-bottom: 30px;
    }
    .site-form-item-icon {
        font-size: 20px;
    }
    .forgot {
        font-size: 15px;
        line-height: 21px;
        font-weight: 500;
        color: #646464;
        text-align: start;
        margin-top: 16px;
        span {
            color: ${(p) => p.bg_color};
            cursor: pointer;
        }
    }
    .remember {
        text-align: start;
        font-weight: 500;
        font-size: 15px;
        line-height: 21px;
        margin-top: 8px;
        color: #646464;
    }
    .login-signup {
        font-weight: 500;
        font-size: 26px;
        line-height: 35px;
        text-align: center;
        color: ${(p) => p.theme.colors.color};
        margin-bottom: 20px;
    }
    .logo-image {
        width: 120px;
        align-items: center;
        margin: auto;
        img {
            width: 120px;
            height: auto;
            border-radius: 60px;
        }
        .ant-skeleton {
            .ant-skeleton-header {
                padding-right: 0;
                span {
                    width: 120px!important;
                    height: 120px;
                    
                }
            }
        }
    }
    .label-sginup {
        /* font-family: "Nunito"; */
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        color: #a5a5a5;
        margin-bottom: 32px;
    }
`;
